import { render } from "./LocaleSelect.vue?vue&type=template&id=44794445"
import script from "./LocaleSelect.vue?vue&type=script&lang=js"
export * from "./LocaleSelect.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__